import * as L from 'leaflet';
/**
 * The Meteotest attribution control.
 */
export class ControlMTAttribution extends L.Control.Attribution {
    /**
     * Create a new Meteotest attribution control.
     */
    constructor() {
        super({ position: 'bottomright', prefix: false });
        this.addAttribution('provided by <a href="https://meteotest.ch/" target="_blank">Meteotest</a>');
    }
    /**
     * Add the custom markup/
     */
    addCustomMarkup() {
        if (this._container) {
            this._container.classList.add('maap_p-control-mt-attribution');
        }
    }
}
//# sourceMappingURL=ControlMTAttribution.js.map